module.exports = __webpack_public_path__ + "MuseoSans-500.edf77ffdf54240aacbfb.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/MuseoSans-500.ttf
// module id = ../../../../../src/assets/fonts/MuseoSans-500.ttf
// module chunks = styles